<script setup lang="ts">
import type { SocialLink } from '@pkg/sanity-utils/linkQueries';
import { colors } from '@pkg/config/tailwind/colors';

interface Props {
  link: SocialLink;
  color?: string;
}

const props = defineProps<Props>();

const lazy = ref(false);

if (process.client) {
  setInterval(() => {
    lazy.value = true;
  }, 500);
}

// Icons inherit their color via `currentColor`, so drive it through `color`
// (defaulting to the brand green) rather than a text-color utility class.
const iconColor = computed(() => props.color ?? colors().green['30']);
const iconStyle = computed(() => ({ fill: iconColor.value, color: iconColor.value }));
</script>

<template>
  <NuxtLink :to="props.link.url" target="_blank" rel="noopener">
    <LazyCmsIcon v-if="lazy" :name="props.link.icon" :style="iconStyle" />
  </NuxtLink>
</template>
